// Frontend API client for MzansiFootball Talent Connect
import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('mft_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Convert a backend-relative URL (e.g. /api/uploads/...) to full URL for image tags
export const absUrl = (u) => {
  if (!u) return '';
  if (u.startsWith('http')) return u;
  return `${BACKEND}${u}`;
};

export const authApi = {
  register: (email, password) => api.post('/auth/register', { email, password }).then(r => r.data),
  login: (email, password) => api.post('/auth/login', { email, password }).then(r => r.data),
  me: () => api.get('/auth/me').then(r => r.data),
  emergentSession: (session_id) => api.post('/auth/session', { session_id }).then(r => r.data),
  logout: () => api.post('/auth/logout').then(r => r.data),
};

export const playersApi = {
  list: (params) => api.get('/players', { params }).then(r => r.data),
  get: (id) => api.get(`/players/${id}`).then(r => r.data),
  save: (payload) => api.post('/players', payload).then(r => r.data),
};

export const uploadsApi = {
  image: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/uploads/image', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
  },
  video: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/uploads/video', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
  },
};

export const subscriptionApi = {
  activate: () => api.post('/subscription/activate').then(r => r.data),
  cancel: () => api.post('/subscription/cancel').then(r => r.data),
};

export default api;
